import React, { Fragment } from 'react';
export function TrustBar() {
  const items = ['Free Auto Glass Estimates', 'Works With Most Insurance', 'Certified Technicians', 'Lifetime Workmanship Warranty', 'OEM & OEE Glass Available', 'ADAS Calibration In-House', 'Howell, Ann Arbor & Novi', 'Same-Day Openings May Be Available'];
  return <div className="bg-navy-900 text-white py-4 border-y border-navy-800" data-id="element-453">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-454">
        <div className="hidden md:flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm font-medium" data-id="element-455">
          {items.map((item, index) => <Fragment key={index} data-id="element-456">
              <span className="whitespace-nowrap text-slate-200" data-id="element-457">{item}</span>
              {index < items.length - 1 && <span className="text-brand-blue font-bold opacity-60" data-id="element-458">•</span>}
            </Fragment>)}
        </div>
        <div className="flex md:hidden flex-wrap justify-center gap-2" data-id="element-459">
          {items.map((item, index) => <span key={index} className="px-3 py-1.5 bg-navy-800 rounded-full text-xs font-medium text-slate-200 border border-navy-700" data-id="element-460">
              {item}
            </span>)}
        </div>
      </div>
    </div>;
}